import type { VRisingProfileNamespace } from "../graphql";
import { i18n } from "../i18n";
import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, Menu, ProfileCtx } from "./types";
const { t } = i18n.global;
const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

function buildConfigSections(ctx: ProfileCtx): ConfigSection[] {
  const sections: ConfigSection[] = [
    { component: "ConfSection", props: { name: "basic" } },
    { component: "BroadcastMessages" },
    { component: "ConfSection", props: { name: "extended" } },
    { component: "ConfSection", props: { name: "pvpSettings" } },
    { component: "ConfSection", props: { name: "castleStatModifier" } },
    { component: "TableSection", props: { name: "vBloodUnitSettings" } },
    { component: "TableSection", props: { name: "unlockedAchievements" } },
    { component: "TableSection", props: { name: "unlockedResearch" } },
  ];

  const profile = ctx.profile as VRisingProfileNamespace | undefined;
  const isLaunchServer = profile?.isLaunchServer;
  const isOfficialServer = profile?.isOfficialServer;
  if (!isOfficialServer) {
    sections.push({ component: "TableSection", props: { name: "adminList" } });
    sections.push({ component: "TableSection", props: { name: "banList" } });
  }
  sections.unshift({
    component: "VRisingServerSetup",
    props: { gloomrotOnly: false, isLaunchServer, isOfficialServer },
  });

  return sections;
}

const join = () => {
  window.open(t("ngp/settings/section/vrising_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (ctx: ProfileCtx) => ({
  menu: createMenu(),
  configSections: buildConfigSections(ctx),
  join: {
    buttonTextKey: "ngp/settings/section/vrising_wiki",
    joinFn: join,
  },
});
